import { z } from 'zod'

export const reportDescriptionEditSchema = z.object({
  report_name: z.string().min(1, 'Name is required'),
  report_label: z.string().min(1, 'Label is required'),
  report_description: z.string().min(1, 'Description is required'),
  report_query: z.string(),
})

export type ReportDescriptionFormValues = z.infer<typeof reportDescriptionEditSchema>
